/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { TranslationProvider } from './components/common/Translation/translationProvider';
import { Config, type ConfigOptions } from '@forgerock/javascript-sdk';
import { configOptionsPWC } from './config/forgerockConfig';
// import { configOptions } from './config/forgerockConfigPW';
/* import '@utdx/theme-variables/pratt/pratt.scss'; */
import '@utdx/theme-variables/raytheon/raytheon.scss';
import { applyPolyfills, defineCustomElements } from '@utdx/rotor-web-components/dist/loader';
import { Provider } from 'react-redux';
import { store } from './redux/store';
//import './fonts/Objektiv_Mk2_Regular.css'
applyPolyfills().then(function () {
  defineCustomElements(window)
});

Config.set(configOptionsPWC as ConfigOptions);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <Provider store={store}>
    <TranslationProvider>
      <App />
    </TranslationProvider>
  </Provider>


);
